import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=7a6788c8&scoped=true"
import script from "./paging.vue?vue&type=script&lang=js"
export * from "./paging.vue?vue&type=script&lang=js"
import style0 from "./paging.vue?vue&type=style&index=0&id=7a6788c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6788c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6788c8')) {
      api.createRecord('7a6788c8', component.options)
    } else {
      api.reload('7a6788c8', component.options)
    }
    module.hot.accept("./paging.vue?vue&type=template&id=7a6788c8&scoped=true", function () {
      api.rerender('7a6788c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paging.vue"
export default component.exports